import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function UpdateAdvBooking({ selectedBooking, closeModal, onUpdate }) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState(selectedBooking.name);
  const [mobileNo, setMobileNo] = useState(selectedBooking.mobileNo);
  const [emailAddress, setEmailAddress] = useState(
    selectedBooking.emailAddress
  );
  const [roomNo, setRoomNo] = useState(selectedBooking.roomNo);
  const [roomType, setRoomType] = useState(selectedBooking.roomType);

  const [startDateValue, setStartDateValue] = useState();
  const [endDateValue, setEndDateValue] = useState();

  useEffect(() => {
    if (selectedBooking) {
      const startDate = moment(selectedBooking.bookingStart)
        .subtract(5, 'hours')
        .subtract(30, 'minutes')
        .toDate();
      const endDate = moment(selectedBooking.bookingEnd)
        .subtract(5, 'hours')
        .subtract(30, 'minutes')
        .toDate();
      setStartDateValue(startDate);
      setEndDateValue(endDate);
    }
  }, [selectedBooking]);

  async function handleDelete() {
    if (selectedBooking) {
      try {
        const response = await axios.post(`/api/deleteAdvanceBooking`, {
          adv_booking_id: selectedBooking.advBookingId,
        });
        if (response.status === 200) {
          alert('Booking deleted successfully');
          closeModal();
          onUpdate();
        } else {
          alert('Error deleting booking');
        }
      } catch (error) {
        console.error('Error deleting booking:', error);
      }
    } else {
      alert('No booking selected.');
    }
  }

  async function handleInfoUpdate(e) {
    e.preventDefault();
    setIsLoading(true);

    if (selectedBooking) {
      const startDateTime = moment(startDateValue).format(
        'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
      );
      const endDateTime = moment(endDateValue).format(
        'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
      );

      const result = await axios('/api/getAllRooms');
      // console.log(result.data);
      const allRooms = result.data;
      let roomDetailsId = null;
      for (let i = 0; i < allRooms.length; i++) {
        if (roomNo === allRooms[i].room_no.toString()) {
          roomDetailsId = allRooms[i].room_details_id;
        }
      }

      const updatedBooking = {
        adv_booking_id: selectedBooking.advBookingId,
        name: name,
        mobile_no: parseInt(mobileNo),
        email_address: emailAddress,
        booking_start: startDateTime,
        booking_end: endDateTime,
        room_details_id: roomDetailsId,
        room_no: roomNo,
        room_type: roomType,
        tenant_id: selectedBooking.tenant_id,
        checked_in: 0,
      };

      try {
        const response = await axios.post(
          '/api/updateAdvanceBooking',
          updatedBooking
        );
        if (response.status === 200) {
          alert('Update status: ' + response.data);
          closeModal();
          onUpdate();
        } else {
          alert('Error: ' + response.data);
          console.error('Error updating booking:', response.data);
        }
      } catch (error) {
        console.error('Error updating booking:', error);
        // Handle error as needed, e.g., show error message to the user
      }
    } else {
      alert('No booking selected.');
    }
    setIsLoading(false);
  }

  return (
    <div>
      <div
        style={{
          minWidth: '300px',
          maxWidth: '500px',
          maxHeight: '80vh',
          overflowY: 'auto',
          margin: 'auto',
        }}
      >
        <div>
          <form
            onSubmit={handleInfoUpdate}
            style={{ width: '400px', margin: '0 auto', textAlign: 'center' }}
          >
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button
                onClick={() => {
                  navigate('/updateCheckin', { state: { selectedBooking } });
                }}
                disabled={selectedBooking.checkedIn !== 0}
                style={{
                  padding: '8px 20px',
                  backgroundColor:
                    selectedBooking.checkedIn === 0 ? '#38b000' : '#FF0000',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor:
                    selectedBooking.checkedIn === 0 ? 'pointer' : 'not-allowed',
                  width: '50%',
                }}
              >
                Check-In
              </button>
            </div>

            <div style={{ marginBottom: '10px', textAlign: 'left' }}>
              <label htmlFor="name">Name:</label>
              <br />
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{
                  marginBottom: '10px',
                  display: 'block',
                  padding: '5px',
                  width: '100%',
                }}
              />
            </div>
            <div style={{ marginBottom: '10px', textAlign: 'left' }}>
              <label htmlFor="mobileNo">Mobile No:</label>
              <br />
              <input
                type="text"
                id="mobileNo"
                value={mobileNo}
                onChange={(e) => setMobileNo(e.target.value)}
                style={{
                  marginBottom: '10px',
                  display: 'block',
                  padding: '5px',
                  width: '100%',
                }}
              />
            </div>
            <div style={{ marginBottom: '10px', textAlign: 'left' }}>
              <label htmlFor="emailAddress">Email Address:</label>
              <br />
              <input
                type="email"
                id="emailAddress"
                value={emailAddress}
                onChange={(e) => setEmailAddress(e.target.value)}
                style={{
                  marginBottom: '10px',
                  display: 'block',
                  padding: '5px',
                  width: '100%',
                }}
              />
            </div>

            <div style={{ marginBottom: '10px', textAlign: 'left' }}>
              <label htmlFor="roomNo">Room No:</label>
              <br />
              <input
                type="text"
                id="roomNo"
                value={roomNo}
                onChange={(e) => setRoomNo(e.target.value)}
                style={{
                  marginBottom: '10px',
                  display: 'block',
                  padding: '5px',
                  width: '100%',
                }}
              />
            </div>
            <div style={{ marginBottom: '10px', textAlign: 'left' }}>
              <label htmlFor="roomType">Room Type:</label>
              <br />
              <select
                id="roomType"
                style={{
                  marginBottom: '10px',
                  display: 'block',
                  padding: '5px',
                  width: '100%',
                }}
                value={roomType}
                disabled
              >
              </select>
            </div>

            <div style={{ display: 'flex', gap: '20px' }}>
              <div>
                <div>Start date:</div>
                <div>
                  <DatePicker
                    selected={startDateValue}
                    showTimeSelect
                    dateFormat="dd-MMM-yy,  hh:mm aa"
                    onChange={(date) => setStartDateValue(date)}
                  />
                </div>
              </div>
              <div>
                <div>End date:</div>
                <div>
                  <DatePicker
                    selected={endDateValue}
                    showTimeSelect
                    dateFormat="dd-MMM-yy,  hh:mm aa"
                    onChange={(date) => setEndDateValue(date)}
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                margin: '10px 0',
              }}
            >
              <button
                type="button"
                onClick={handleDelete}
                style={{
                  padding: '6px 16px',
                  backgroundColor: '#FF0000',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  width: '45%',
                }}
              >
                Delete
              </button>
              <button
                type="submit"
                disabled={isLoading}
                style={{
                  padding: '6px 16px',
                  backgroundColor: '#007bff',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  width: '45%',
                }}
              >
                {isLoading ? 'Updating...' : 'Update'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UpdateAdvBooking;
